/** The absence products `integrators/officient/absentDay.ts` prefers when it files a day off, so a day lands here wherever the org has one of them. An org with none keeps its own wording and its days do not stripe. */
export const ABSENCE_PRODUCTS = ['Holiday', 'Public holiday', 'Sick day', 'No contract'];

/** Case and surrounding space only, the same comparison the absence job picks a product by. */
export const isAbsenceProduct = (name?: string): boolean =>
  !!name && ABSENCE_PRODUCTS.some(absence => absence.toLowerCase() === name.trim().toLowerCase());
